import countries from './countries.json'

export const getFlagEmoji = name => {
  const country = countries.find(c => c.name === name)
  return country ? country.emoji : ''
}
